import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import {
    Alert,
    Container,
    Header as HeaderRS,
    Content,
    Footer,
    Sidebar as Side } from 'rsuite';
import { Header,
    Form,
    Button,
    Segment,
    Icon,
    Dropdown,
    Divider,
    List } from 'semantic-ui-react';

import { api } from '../../../services/api';
import { formatDate } from '../../../utils';

import Navbarr from '../../../components/Navbar';

import './styles.css';

export default function StoreViewEdit ({ sidebar: Sidebar}) {
    const { id } = useParams();
    const [storeStates, setStoreStates] = useState({
        store: {},
        formStore: {
            id: '',
            nome: '',
            endereco: '',
            rotas: [],
            produtos: [],
            admins: []
        },
        products: [],
        productsOptions: [],
        currentProducts: [],
        routes: [],
        routesOptions: [],
        currentRoutes: [],
        isLoadingData: true,
        isEditing: false
    });

    async function handleProdRoutes() {
        await handleProducts();
        await handleRoutes();

    }

    async function handleProducts() {
        const currentProducts = [];
        const productsOptions = [];
        const products = await fetchOwnProducts();
        products.forEach(
            prod => {
                productsOptions.push({key: prod['id'],
                                    text: prod['nome'],
                                    value: prod['id']});
            }
        );

        storeStates['store']['produtos'].forEach(
            prod => {
                currentProducts.push(prod['id']);
            }
        );

        //handleAdditionP(null, {value: currentProducts});
        handleProductChange(null, {value: currentProducts});

        setStoreStates(state => ({
            ...state,
            products: products,
            productsOptions: productsOptions,
        }));
    }

    async function handleRoutes() {
        const currentRoutes = [];
        const routesOptions = [];
        const routes = await fetchRoutes();
        routes.forEach(
            route => {
                routesOptions.push({key: route['id'],
                                    text: route['nome'],
                                    value: route['id']});
            }
        );

        storeStates['store']['rotas'].forEach(
            route => {
                currentRoutes.push(route['id']);
            }
        );

        //handleAddition(null, {value: currentRoutes});
        handleRotaChange(null, {value: currentRoutes});
        setStoreStates(state => ({
            ...state,
            routes: routes,
            routesOptions: routesOptions,
        }));
    }

    async function fetchOwnProducts() {
        try {
            const data = await api.getOwnProducts();
            return data;
        } catch (err) {
            console.error("Falha ao obter produtos: ", err);
        }
    }

    async function fetchRoutes() {
        try {
            const data = await api.getRoutes();
            return data;
        } catch (err) {
            console.error("Falha ao obter rotas: ", err);
        }
    }

    const handleProductChange = (e, {value}) => {
        setStoreStates((prevState) => ({
            ...prevState,
            currentProducts: value
        }));
    }

    const handleRotaChange = (e, {value}) => {
        setStoreStates((prevState) => ({
            ...prevState,
            currentRoutes: value
        }));
    }

    async function editStore () {
        setStoreStates(prevState => ({
            ...prevState,
            isLoadingData: true
        }));

        await handleProdRoutes();

        setStoreStates(state => ({
            ...state,
            isEditing: true,
            isLoadingData: false,
        }));
    }

    const handleNomeChange = (e, {value}) => {
        setStoreStates( state => ({
            ...state,
            formStore: {
                ...state['formStore'],
                nome: value
            }
        }));
    }

    const handleEndChange = (e, {value}) => {
        setStoreStates( state => ({
            ...state,
            formStore: {
                ...state['formStore'],
                endereco: value
            }
        }));
    }

    const cancelStoreEdit = () => {
        setStoreStates( state => ({
            ...state,
            formStore: state['store'],
            isEditing: false
            }
        ));
    }

    async function handlePut() {
        try {

            setStoreStates( state => ({
                ...state,
                isLoading: true,
            }));

            const rotas = [];
            const produtos = [];
            const admins = [];

            storeStates['currentRoutes'].forEach(
                route => rotas.push({'id':route})
            );

            storeStates['currentProducts'].forEach(
                produto => produtos.push({'id':produto})
            );
            storeStates['formStore']['admins'].forEach(
                admin => admins.push({'email':admin['email']})
            );


            const data = await api.putStore(storeStates['formStore']['id'],
                                            storeStates['formStore']['nome'],
                                            storeStates['formStore']['endereco'],
                                            rotas, produtos, admins);
            Alert.success('Loja atualizada com sucesso!');
            setStoreStates( state => ({
                ...state,
                store: data,
                formStore: {
                    ...state['formStore'],
                    ...data
                },
                isLoadingData: false,
                isEditing: false
            }));
        } catch (err) {
            Alert.error('Falha ao atualizar loja.');
            console.error('Falha ao atualizar loja: ', err);
            setStoreStates( state => ({
                ...state,
                isLoadingData: false,
                isEditing: true
            }));
        }
    }

    useEffect(() => {
        async function fetchStore() {
            try {
                const data = await api.getStoreById(id);
                setStoreStates( state => ({
                    ...state,
                    store: data,
                    formStore: {
                        ...state['formStore'],
                        ...data,
                        dataCriacao: formatDate(data['dataCriacao']),
                        dataAlteracao: formatDate(data['dataCriacao'])
                    },
                    isLoadingData: false
                }));
            } catch (err) {
                console.error("Falha ao obter loja: ", err);
            }
        }

        fetchStore();
    },[id]);

    return (
        <Container>
            <Side style={{ flex: '0 0 auto', width: 'auto' }}>
                <Sidebar page={"storelist"}></Sidebar>
            </Side>
            <Container>
                <HeaderRS>
                    <Navbarr></Navbarr>
                </HeaderRS>
                <Content style={{backgroundColor: '#FAFAFA', padding: '5px'}}>
                    <div>
                        <Segment
                            loading={storeStates['isLoadingData']}
                            style={{ boxShadow: '0 0 0 0 rgba(255, 255, 255, 0)' }}
                            >
                            <Header as='h3' floated='left'>
                                Informações da Loja
                            </Header>
                            {!storeStates['isEditing'] && <Button
                                primary
                                size="mini"
                                floated='right'
                                onClick={editStore}
                                >
                                    <div style={{ verticalAlign: 'middle', width: '70px', fontSize: '10px'}}>
                                        <Icon name='edit'/> Editar
                                    </div>
                            </Button>}

                            <Divider clearing />
                            <Form>
                                <Form.Group inline>
                                    </Form.Group>
                                    <Form.Group widths='equal'>
                                        <Form.Input
                                            readOnly={true}
                                            iconPosition='left'
                                            icon='key'
                                            fluid label='Identificador'
                                            placeholder='Identificador'
                                            value={storeStates['formStore'] ? storeStates['formStore']['id']: ""}
                                            />

                                        <Form.Input
                                            readOnly={!storeStates['isEditing']}
                                            iconPosition='left'
                                            icon='shop'
                                            fluid label='Nome'
                                            placeholder='Nome'
                                            value={storeStates['formStore'] ? storeStates['formStore']['nome']: ""}
                                            onChange={handleNomeChange}
                                        />
                                    </Form.Group>
                                    <Form.Group widths='equal'>
                                        <Form.Input
                                            readOnly={!storeStates['isEditing']}
                                            iconPosition='left'
                                            icon='map marker alternate'
                                            fluid label='Endereço'
                                            placeholder='Endereço'
                                            value={storeStates['formStore'] ? storeStates['formStore']['endereco']: ""}
                                            onChange={handleEndChange}
                                        />
                                    </Form.Group>
                                    {storeStates['formStore'] && !storeStates['isEditing'] && <Form.Group widths='equal'>
                                        <Form.Input
                                            readOnly={true}
                                            iconPosition='left'
                                            icon='calendar alternate'
                                            fluid label='Criação'
                                            placeholder={storeStates['formStore'] ? storeStates['formStore']['dataCriacao']: ""}
                                            //value={storeStates['formStore'] ? storeStates['formStore']['dataCriacao']: ""}
                                            />
                                        <Form.Input
                                            readOnly={true}
                                            iconPosition='left'
                                            icon='calendar alternate'
                                            fluid label='Última alteração'
                                            placeholder={storeStates['formStore'] ? storeStates['formStore']['dataAlteracao']: ""}
                                            //value={storeStates['formStore'] ? storeStates['formStore']['dataAlteracao']: ""}
                                        />
                                    </Form.Group> }

                                    {/* Dropdown rotas*/}
                                    {storeStates['formStore'] && storeStates['isEditing'] &&
                                        <Form.Group inline style={{marginBottom: '4px'}}>
                                            <label>Rotas</label>
                                        </Form.Group>
                                    }
                                    {storeStates['formStore'] && storeStates['isEditing'] &&
                                        <Form.Group inline>
                                            <Dropdown
                                                disabled={!storeStates['isEditing']}
                                                options={storeStates['routesOptions']}
                                                placeholder='Escolha rotas'
                                                search
                                                selection
                                                fluid
                                                multiple
                                                value={storeStates['currentRoutes']}
                                                onChange={handleRotaChange}
                                            />
                                        </Form.Group>
                                    }

                                    {/* Dropdown produtos*/}
                                    {storeStates['formStore'] && storeStates['isEditing'] &&
                                        <Form.Group inline style={{marginBottom: '4px'}}>
                                            <label>Produtos</label>
                                        </Form.Group>
                                    }

                                    {storeStates['formStore'] && storeStates['isEditing'] &&
                                        <Form.Group inline>
                                            <Dropdown
                                                disabled={!storeStates['isEditing']}
                                                options={storeStates['productsOptions']}
                                                placeholder='Escolha produtos'
                                                search
                                                selection
                                                fluid
                                                multiple
                                                value={storeStates['currentProducts']}
                                                onChange={handleProductChange}
                                            />
                                        </Form.Group>
                                    }

                                    {storeStates['formStore'] && !storeStates['isEditing']
                                        &&
                                        <Header as='h4' dividing>
                                            <Header.Content>
                                                Rotas
                                            </Header.Content>
                                        </Header>
                                    }
                                    {storeStates['formStore'] && !storeStates['isEditing'] && <List divided relaxed style={{marginTop: '30px'}}>
                                        {storeStates['formStore']['rotas'].map((rota) => {
                                            return (
                                                <List.Item key={rota['id']}>
                                                    <List.Content>
                                                        <List.Header style={{fontSize: '13px'}}>
                                                            {rota['nome']}
                                                        </List.Header>
                                                        <List.Description style={{fontSize: '12px'}}>Identificador {rota['id']}</List.Description>
                                                    </List.Content>
                                                </List.Item>
                                                )
                                            })
                                        }
                                    </List> }

                                    {storeStates['formStore'] && !storeStates['isEditing']
                                        &&
                                        <Header as='h4' dividing>
                                            {/*<Icon name='coffee' />*/}
                                            <Header.Content>
                                                Produtos
                                            </Header.Content>
                                        </Header>
                                    }
                                    {storeStates['formStore'] && !storeStates['isEditing'] && <List divided relaxed style={{marginTop: '30px'}}>
                                        {storeStates['formStore']['produtos'].map((produto) => {
                                            return (
                                                <List.Item key={produto['id']}>
                                                    <List.Content>
                                                        <List.Header style={{fontSize: '13px'}}>
                                                            {produto['nome']}
                                                        </List.Header>
                                                        <List.Description style={{fontSize: '12px'}}>Identificador {produto['id']}</List.Description>
                                                    </List.Content>
                                                </List.Item>
                                                )
                                            }
                                        )
                                    }
                                    </List> }

                                    <Form.Group>
                                        {storeStates['isEditing'] && <Button
                                            style={{marginLeft: '7px', marginTop: '7px'}}
                                            primary
                                            type='submit'
                                            size="mini"
                                            floated='right'
                                            onClick={handlePut}
                                            >
                                                <div style={{ verticalAlign: 'middle', width: '70px', fontSize: '10px'}}>
                                                    <Icon name='save'/> Salvar
                                                </div>
                                        </Button>}
                                        {storeStates['isEditing'] && <Button
                                            style={{marginLeft: '7px', marginTop: '7px'}}
                                            color='red'
                                            size="mini"
                                            floated='right'
                                            onClick={cancelStoreEdit}
                                            >
                                                <div style={{ verticalAlign: 'middle', width: '70px', fontSize: '10px'}}>
                                                    <Icon name='cancel'/> Cancelar
                                                </div>
                                        </Button>}
                                    </Form.Group>
                                </Form>
                        </Segment>
                    </div>
                </Content>
                <Footer></Footer>
            </Container>
        </Container>
    );
}
